import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from 'FrontRoyalAngular';
import { getCohort } from 'Users';
import { ProgramTypeConfigs } from 'Program';
import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { BasicMobileBox } from '../../BasicMobileBox';
import { BasicDesktopBox } from '../../BasicDesktopBox';

function OpenCoursesBoxComponent({ mobile }: { mobile?: boolean }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'openCoursesBox' });
    const currentUser = useCurrentUser();
    const cohort = useMemo(() => getCohort(currentUser), [currentUser]);
    const content = useMemo(() => {
        if (!cohort) return null;
        const contentKey = ProgramTypeConfigs[cohort.programType].openCoursesSidebarBoxContentKey;
        if (!contentKey) return null;
        return t(contentKey);
    }, [cohort, t]);

    if (!content) return null;

    return mobile ? (
        <OpenCoursesBoxMobilePresentation content={content} />
    ) : (
        <OpenCoursesBoxPresentation content={content} />
    );
}

function OpenCoursesBoxMobilePresentation({ content }: { content: string }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'openCoursesBox' });
    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.open_courses}
            heading={t('heading')}
            ctaText={t('button_more')!}
            expandedContent={<OpenCoursesBoxPresentation content={content} />}
        />
    );
}

function OpenCoursesBoxPresentation({ content }: { content: string }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'openCoursesBox' });

    return (
        <BasicDesktopBox headerText={t('heading')} boxKey={SidebarBoxKey.open_courses}>
            {content}
        </BasicDesktopBox>
    );
}

export const OpenCoursesBox = memo(OpenCoursesBoxComponent);
